import React, { Component } from "react";
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';

//Engage Components
import {
    renderSwitchWithLabel,
    renderSelectV2
} from '../../utils/engageComponents';


//Material-UI Components
import Grid from '@material-ui/core/Grid';
import Checkbox from "@material-ui/core/Checkbox";
import Modal from '@material-ui/core/Modal';

//Actions
import { SetHeaderButtons } from '../../actions/headerButtonsActions';
import { GetHomeApps, UpdateHomeAppByCommunity, GetTVHomeApps, UpdTVHomeApps } from '../../actions/homeAppsActions';
import { getResidentsByCommunity } from '../../actions/residentActions'
import ModalTvHomeApps from "./ModalTvHomeApps";

import {sweetAlert} from '../../components/Alert/sweetAlert'


class CommunitySettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //Apps Status
            initialAppsStatus: undefined,
            appsStatus: undefined,
            //SwitchSelectAll
            switchAllCommunitiesSelected: false,
            // rootFontSize
            rootFontSize: props.rootFontSize,
            showModalTVHomeApps: false
            //
        };

    }

    //#region life cycle  methods
    //This method will run once the componnet is deploy to the browser
    componentDidMount() {
        document.title = 'Community - Settings'
        // this.SetHeaderButtons();
        if (this.props.communitySelected) {
            const communityId = this.props.communitySelected?.communityId;
            const idCommunity = this.props.communitySelected?._id;

            this.props.GetHomeApps(communityId);
            this.props.GetTVHomeApps(communityId);
            this.props.getResidentsByCommunity(idCommunity);
        }
    };


    componentWillUnmount() {
        this.clear();
    };

    //#endregion    

    //#region methods
    SetHeaderButtons = () => {
        const headerButtons = this.getHeaderButtons();
        this.props.SetHeaderButtons(headerButtons)
    };

    getHeaderButtons = () => {
        return (
            <Grid item container justify='flex-end' alignContent='center'>
                <Grid className="appbtn-engage skybluebtn-engage appbtn-list-engage" onClick={this.handlerSaveClick} style={{ marginLeft: '5px', marginRight: '5px' }}>
                    save
                </Grid>
            </Grid>
        );
    };


    clear = () => {
        this.setState({
            initialAppsStatus: undefined,
            appsStatus: undefined,
            switchAllCommunitiesSelected: false,
        });

    }

    setNewStatusApi = () => {
        if (this.props.UpdateHomeAppByCommunity && this.props.GetHomeApps) {

            const communityId = this.props.communitySelected?.communityId;
            const newArrayHomeApps = this.GetHomeAppsUpdateArray();

            if (newArrayHomeApps && communityId) {
                let residentid = this.state?.residentSelected?._id;
                residentid = residentid !== '000' ? residentid : undefined;

                this.props.UpdateHomeAppByCommunity(newArrayHomeApps, communityId, residentid, localStorage.getItem('userName'));

                this.clear();
                this.props.handleClose();
            }
        }

    };

    GetHomeAppsUpdateArray = () => {
        let newAppsArray = [];

        if (this.state.appsStatus) {
            newAppsArray = this.state.appsStatus.map(homeApp => {
                return {
                    "_id": homeApp._id,
                    "name": homeApp.appName,
                    "active": homeApp.active
                }
            });
        }

        return newAppsArray;
    };

    setInitialState = () => {

        //Get Initial resident selected (first element) if not exist
        let intialResidentSelected = this.state?.residentSelected;

        if (!intialResidentSelected && this.props.residentData && this.props.residentData.length > 0) {
            intialResidentSelected = this.props.residentData[0];
        };

        let initialAppsStatus = [];


        initialAppsStatus = this.props.homeAppsData.map(app => {
            const active = (app.tileAvailable) ? app.tileAvailable : false;
            const iconUrl = app.iconUrl ? app.iconUrl : undefined;

            return {
                '_id': app._id,
                'appName': app.name,
                'active': active,
                'iconUrl': iconUrl,
            }
        });


        //Get state of the siwtch for select all
        const allCommunitiesSelected = !initialAppsStatus.some(el => el.active === false);

        //Create 2 separeta arrays for the Apps Status (No reference)
        const initialStatus = initialAppsStatus.map(x => Object.assign({}, x));
        const currentStatus = initialAppsStatus.map(x => Object.assign({}, x));

        //Set state
        this.setState(
            {
                startHomeApps: this.props.homeAppsData,
                initialAppsStatus: initialStatus,
                appsStatus: currentStatus,
                switchAllCommunitiesSelected: allCommunitiesSelected,
                residentSelected: intialResidentSelected
            })
    }

    //#endregion

    //#region  Handlers
    handlerSaveClick = (formData) => {
        this.setNewStatusApi();
    }

    handleCheckBoxClick = (appObject) => {
        let newAppObject = { ...appObject };
        newAppObject.active = !(appObject.active)

        const oldAppStatus = this.state.appsStatus ? this.state.appsStatus : []
        const newAppStatus = [...oldAppStatus.filter(item => item._id !== newAppObject._id), newAppObject]

        const allCommunitiesSelected = !newAppStatus.some(el => el.active === false);

        this.setState({ appsStatus: newAppStatus, switchAllCommunitiesSelected: allCommunitiesSelected });
    };

    handlerToggleAllCommunities = () => {
        const newSwitchState = !this.state.switchAllCommunitiesSelected;

        const oldAppsStatus = this.state.appsStatus;
        let newAppsStatus = [...oldAppsStatus];

        newAppsStatus.forEach(item => item.active = newSwitchState);

        this.setState({ appsStatus: newAppsStatus, switchAllCommunitiesSelected: newSwitchState });

    };

    handlerSetResidentSelected = (residentSelected) => {
        if (residentSelected) {
            this.setState({ residentSelected: residentSelected, appsStatus: undefined });
            this.props.dispatch(change('CommunitySettingsForm', 'SelectResident', residentSelected));

            const communitytid = this.props.communitySelected?.communityId;
            const residentid = residentSelected._id

            this.props.GetHomeApps(communitytid, (residentid !== '000') ? residentid : undefined);
        }
    };

    //#endregion

    //#region Inner Components  --Apps Componnets--
    AppsContainer = () => {
        const styles = {
            container: {
                backgroundColor: '#1f1f1f',
                borderRadius: '12px',
                marginTop: '30px'
            }
        }
        return (
            <Grid container style={{ ...styles.container }}>
                <Grid item container justifyContent='flex-start' style={{ padding: '0px 5px', margin: '0px 15px', }} >
                    <Grid item xs={6} md={4} lg={2} style={{ padding: '15px 0' }} >
                        <Field
                            idToSet='settings_selectAll_switch'
                            label={'Select All '}
                            checked={this.state.switchAllCommunitiesSelected ? this.state.switchAllCommunitiesSelected : false}
                            onClick={() => this.handlerToggleAllCommunities()}
                            component={renderSwitchWithLabel}
                            labelInLeft={false}
                            stylesLabel={{}}
                        />
                    </Grid>
                </Grid>
                {
                    this.props.homeAppsData ?
                        this.props.homeAppsData.map(app => {
                            return (
                                <this.AppContainer
                                    key={`app${app.name ? app.name : undefined}`}
                                    app={app}
                                />
                            )
                        }
                        )
                        :
                        undefined
                }
            </Grid>
        )
    };

    AppContainer = ({ app }) => {

        const style = {
            appContainer: {
                borderRadius: '12px',
                height: '150px',
                backgroundColor: '#000000',
                marginBottom: '10px'
            },
        }

        const size = this.props.rootFontSize?.name;

        return (
            <Grid item container xs={(size === 'lg' || size === 'xl') ? 3 : size === 'md' ? 4 : size === 'sm' ? 6 : 12} justify='center' alignContent='center'>
                <Grid item container xs={10} style={{ ...style.appContainer }}>
                    <this.AppComponent
                        app={app}
                    />
                </Grid>
            </Grid>
        )

    };

    AppComponent = ({ app }) => {
        if (!app) return;

        const appStatusObject = this.state.appsStatus.find(item => item._id === app._id);

        return (
            <Grid item container  >
                {
                    appStatusObject ?
                        <Grid id={`settings_HomeApp_${appStatusObject.appName}`} item container >
                            <this.BadgeContainer
                                appObject={appStatusObject}
                            />
                            <this.NameContainer
                                appObject={appStatusObject}
                            />
                        </Grid>
                        :
                        undefined
                }
            </Grid>
        )
    };

    BadgeContainer = ({ appObject }) => {

        const style = {
            badgeContainer: {
                borderTopLeftRadius: '12px',
                borderTopRightRadius: '12px',
                height: '60%',
                backgroundColor: '#92949c',
            },
        }
        return (
            <Grid item container justifyContent='center' alignContent='center' style={{ ...style.badgeContainer }}>
                <this.GetBadge
                    appObject={appObject}
                />
            </Grid>
        );
    };

    GetBadge = ({ appObject }) => {

        const styles = {
            container: {
                height: '80px',
                width: '125px',
                borderRadius: '12px',

            },
            img: {
                width: '70px',
                height: '70px',
            }
        }
        return (
            <Grid item container style={{ ...styles.container }} justifyContent='center' alignContent='center'>
                {
                    appObject.iconUrl ?
                        <img
                            alt="CommunityLogo"
                            style={{ ...styles.img, }}
                            src={appObject.iconUrl}
                        />
                        :
                        <Grid item container justifyContent='center' alignItems='center' style={{ ...styles.img }}>
                            <Grid item>
                                {
                                    appObject.appName ?
                                        appObject.appName.split(' ').map(word => word.slice(0, 1).toUpperCase()).join('')
                                        :
                                        undefined
                                }
                            </Grid>
                        </Grid>
                }
            </Grid>
        );
    }

    NameContainer = ({ appObject }) => {

        const style = {
            NameContainer: {
                borderBottomLeftRadius: '12px',
                borderBottomRightRadius: '12px',
                height: '40%',
            },
        }

        return (
            <Grid item container justifyContent='center' alignContent='center' style={{ ...style.NameContainer }}>
                <Grid item style={{}}>
                    <Checkbox
                        id={appObject ? `settings_HomeApp_${appObject.appName}_checkbox` : undefined}
                        checked={appObject.active}
                        onChange={() => this.handleCheckBoxClick(appObject)}
                        name={`checkBox_${appObject.appName}`}
                        className={appObject.active ? 'isChecked' : ''}
                    />
                </Grid>
                <Grid item style={{ margin: 'auto 0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline' }}>
                    {(appObject.appName.length >= 15) ? appObject.appName.slice(0.12) + '...' : appObject.appName}
                </Grid>

            </Grid>
        );
    };
    //#endregion

    //#region  Inner Components --Residents Components--
    ResidentsContainer = ({ residentSelected, residents }) => {
        const style = {
            container: {
                backgroundColor: '#1f1f1f',
                borderRadius: '12px'
            }
        }

        return (
            <Grid item container xs={12} justifyContent='center'>
                <Grid item container style={style.container}>
                    <Grid item xs={12} md={5} lg={4} style={{ padding: '15px 15px' }}>
                        <this.ResidentComponent residentSelected={residentSelected} residents={residents} />
                    </Grid>
                </Grid>
            </Grid>
        )

    };

    ResidentComponent = ({ residentSelected = {}, residents = [] }) => {

        return (
            <React.Fragment>
                <Grid item container >Residents</Grid>
                <Field
                    showStartAdornment={true}
                    name="SelectResident"
                    disabled={false}
                    maxLength={20}
                    selected={residentSelected ? residentSelected : { name: '' }}
                    optionsItemsIconsData={residents}
                    onChangeHandler={(e, newItem) => this.handlerSetResidentSelected(newItem)}
                    component={renderSelectV2}
                    diableClear={true}
                    idToSet="settings_renderSelect"
                    id='settings_renderSelect'
                />
            </React.Fragment>
        );
    }
    //#endregion

    OnCancelHandler = () => {
        this.setState({ showModalTVHomeApps: false });
    };

    OnSaveHandler = (newTvHomeAppsList) => {
        this.props.UpdTVHomeApps(newTvHomeAppsList, this.props.communitySelected?.communityId)
        this.setState({ showModalTVHomeApps: false });
    }

    render() {
        const { handleSubmit } = this.props;

        if (this.props.homeAppsData && this.props.residentData) {
            if ((!this.state.appsStatus) || (this.state.startHomeApps !== this.props.homeAppsData)) {

                this.setInitialState();
            }
        }

        return (
            <div >
                <form >
                    <Grid container justify='center' style={{}}>
                        <Grid item container justify='center' xs={12}>
                            <div className="imgalignrigth-engage appbtn-details-engage">
                                <Grid item container justifyContent='flex-end' alignContent='center'>
                                    <Grid id="save_Community_Settings_btn" className="appbtn-engage skybluebtn-engage appbtn-list-engage" onClick={handleSubmit(this.handlerSaveClick.bind(this))} style={{ marginLeft: '5px', marginRight: '5px', border: '1px solid red' }}>
                                        save
                                    </Grid>
                                    <Grid id="open_Community_Home_App" className="appbtn-engage skybluebtn-engage appbtn-list-engage" onClick={() => this.setState({ showModalTVHomeApps: true })} style={{ marginLeft: '5px', marginRight: '5px', border: '1px solid red' }}>
                                        Open Home App
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>
                    </Grid>
                    {
                        this.state.appsStatus ?
                            <React.Fragment>
                                <this.ResidentsContainer residentSelected={this.state?.residentSelected} residents={this.props?.residentData} />
                                {
                                    <this.AppsContainer />
                                }
                            </React.Fragment>
                            :
                            undefined
                    }

                    <Modal
                        open={this.state.showModalTVHomeApps}
                        onClose={() => this.setState({ showModalTVHomeApps: false })}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ borderRadius: '16px' }}
                    >
                        <ModalTvHomeApps
                            OnCancelHandler={this.OnCancelHandler}
                            OnSaveHandler={this.OnSaveHandler}
                            homeApps={this.props.tvHomeAppsData}
                        />
                    </Modal>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {

    const homeAppsData = (state.homeAppsReducer && state.homeAppsReducer.homeAppsData) ? state.homeAppsReducer.homeAppsData : undefined;
    const tvHomeAppsData = (state.homeAppsReducer && state.homeAppsReducer.tvHomeAppsData) ? state.homeAppsReducer.tvHomeAppsData : undefined;
    let residentData = (state.residentReducer && state.residentReducer.residentData) ? state.residentReducer.residentData : undefined;

    if (residentData && Array.isArray(residentData)) {
        residentData = residentData.map(item => {
            return {
                _id: item._id,
                name: `${item.firstName} ${item.lastName}`
            }
        })
    }

    const allresidentsObj = {
        _id: '000',
        name: 'All residents',
    }

    let residentReturnObj = [];

    if (residentData) {
        residentReturnObj = [allresidentsObj, ...residentData];
    } else {
        residentReturnObj = [allresidentsObj];
    }

    
    return {
        homeAppsData: homeAppsData,
        tvHomeAppsData: tvHomeAppsData,
        residentData: residentReturnObj,
    };
}

export default connect(mapStateToProps, { SetHeaderButtons, GetHomeApps, UpdateHomeAppByCommunity, getResidentsByCommunity, GetTVHomeApps, UpdTVHomeApps })(reduxForm({
    form: 'CommunitySettingsForm',
    enableReinitialize: true
})(CommunitySettings));